import type { FunctionComponent } from 'react';
import { getForgeMcpAppName } from '#definitions/consent-info';
import { useInfo } from '../../../Flow/ConsentContextProvider';
import ConsentLegalDisclaimer from '../../shared/agent-consent/LegalDisclaimer/LegalDisclaimer';
import { useAtlassianBrand } from '../mcpTerminology';
import { mcpLegalDisclaimerMessages } from './messages';

const LegalDisclaimer: FunctionComponent<{
  showMcpServerAddendum?: boolean;
}> = ({
  showMcpServerAddendum = false,
}: {
  showMcpServerAddendum?: boolean;
}) => {
  const product = useAtlassianBrand();
  const info = useInfo();
  const appName = getForgeMcpAppName(info);
  const target = info.forgeMcpConsentTarget;
  let agreementLinks: { id: string; defaultMessage: string; description: string };

  if (appName) {
    agreementLinks = mcpLegalDisclaimerMessages.forgeAgreementLinks;
  } else if (showMcpServerAddendum) {
    agreementLinks = mcpLegalDisclaimerMessages.mcpServerAddedAgreementBulletTwo;
  } else {
    agreementLinks = mcpLegalDisclaimerMessages.agreementBulletTwo;
  }

  return (
    <ConsentLegalDisclaimer
      product={product}
      messages={{
        agreementHeader: mcpLegalDisclaimerMessages.agreementHeader,
        agreementLinks,
        privacyPolicy: mcpLegalDisclaimerMessages.privacyPolicy,
        termsOfUse: mcpLegalDisclaimerMessages.termsOfUse,
      }}
      forgeApp={
        appName
          ? {
              name: appName,
              vendorName: target?.vendorName?.trim() || undefined,
              privacyPolicy: target?.privacyPolicy?.trim() || undefined,
            }
          : undefined
      }
    />
  );
};

export default LegalDisclaimer;
